<script setup lang="ts">
import {
  useBrowserStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppBasePlaceholder } from '@libs/ui';

import type {
  ItineraryAccommodationUpsellLoaderSegment,
  ItineraryAccommodationUpsellSegment,
} from '../../../../models';
import { AppPlaceholderEventType } from '../../../../models';
import ItineraryTimeline from '../../ItineraryTimeline.vue';
import { useTripOverviewPageStore } from '../../../../stores';

const { t } = i18n.global;

interface AccommodationUpsellSegmentProps {
  segment:
    | ItineraryAccommodationUpsellSegment
    | ItineraryAccommodationUpsellLoaderSegment;
  isLoading?: boolean;
}

const props = defineProps<AccommodationUpsellSegmentProps>();

const browserStore = useBrowserStore();
const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();

function addHotel(): void {
  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
  statsigEventsStore.logTripOverviewAccommodationUpsellHotelAdded();
}
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template #banner>
      <AppBasePlaceholder
        class="accommodation-placeholder"
        :title="t('overview_placeholder.accommodation.title')"
        :description="t('overview_placeholder.accommodation.description')"
        :is-small-device="browserStore.isSmallerThan900px"
        :icon-properties="{
          name: 'accommodation',
          color: 'color-brand-violet',
        }"
        :actions="[
          {
            textToDisplay: t('placeholder.add_hotel'),
            eventType: AppPlaceholderEventType.AddHotel,
          },
        ]"
        :is-loading="props.isLoading"
        @action-clicked="addHotel"
      />
    </template>
  </ItineraryTimeline>
</template>
